import { render, staticRenderFns } from "./AuctionInfo.vue?vue&type=template&id=587c59fd&"
import script from "./AuctionInfo.vue?vue&type=script&lang=js&"
export * from "./AuctionInfo.vue?vue&type=script&lang=js&"
import style0 from "./AuctionInfo.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports